<template>
  <div>
    <modal
      name="aboutModal"
      :scrollable="true"
      delay="2000"
      width="100%"
      height="auto"
      style="z-index: 9998;"
      @closed="closeModal"
    >
      <div id="modalAreaAbout" class="modalArea">
        <div class="content">
          <h2>相模原市フォトスポットサイトとは</h2>
          <p>
            東京都心まで約1時間という利便性の高さを持ち、リニア中央新幹線駅の設置が予定されています。また、川や山、湖などの豊かな自然を身近に感じることができる都市と自然がベストミックスするまちです。<br>
            <br>
            相模原を好きな「さがみはらファン」を増やす取組の一環として<br>
            フォトコンテストを開催し、相模原市の魅力が詰まった作品を<br>
            ご投稿いただきました。<br>
            <br>
            本サイトでは、フォトコンテストで集まった秀逸の作品を<br>
            フォトスポットともにご紹介しています。<br>
            フォトスポットを巡って、相模原の魅力を感じてみませんか？<br>
            <br>
            フォトコンテストの詳細はこちら<br>
            <a href="https://sagamihara.tokyocameraclub.com/contest2023" target="_blank" rel="noopener noreferrer">https://sagamihara.tokyocameraclub.com/contest2023</a><br>
            相模原市公式Instagramはこちら<br>
            <a href="https://www.instagram.com/sagamihara_pr/" target="_blank" rel="noopener noreferrer">https://www.instagram.com/sagamihara_pr/</a><br>
            相模原市公式Twitterはこちら<br>
            <a href="https://twitter.com/Sagamihara_PR" target="_blank" rel="noopener noreferrer">https://twitter.com/Sagamihara_PR</a><br>
            観光情報はこちら<br>
            <a href="https://www.e-sagamihara.com/" target="_blank" rel="noopener noreferrer">https://www.e-sagamihara.com/</a><br>
          </p>
        </div><!-- /content -->
      </div><!-- /modalArea -->
      <div v-if="open" class="closeModalBotton fade" @click="closeModal"><img src="/img/blank.gif"></div>
    </modal>
  </div>
</template>

<script>
export default {
  props: [
    'open'
  ],
  methods: {
    closeModal () {
      this.$emit('update:open', false)
      this.$modal.hide('aboutModal')
      const path = '/'
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
      document.title = '相模原市フォトスポットサイト'
    }
  },
  watch: {
    open (val) {
      if (val) {
        this.$modal.show('aboutModal')
      }
    }
  }
}
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.8) !important;
}
.vm--modal {
  background-color:rgba(0,0,0,0) !important;
}
</style>
